import DiplomaSupplementPage from "./DiplomaSupplementPage";

export default DiplomaSupplementPage;